// Factoring availability = min(limit, collateral) - debt, and it can be negative.

// Effective ceiling the debt is measured against: the limit capped by the collateral.
export const getFactoringCap = (limit: number, collateral: number): number =>
  Math.max(0, Math.min(limit, collateral));

// Share of the cap that is still free (0-100), never NaN or negative.
export const getFactoringRemainingPercent = (cap: number, debt: number): number =>
  cap > 0 ? Math.min(100, Math.max(0, ((cap - debt) / cap) * 100)) : 0;
